<template>
  <vk-carousel
      ref="carousel"
      class="BUTTONS-CAROUSEL "
      arrows-hidden
      @scroll-done="updateActiveIndex"
  >
    <template slot="custom">
      <vk-carousel-arrow v-if="hasArrows" :size="48" class="ARROW LEFT"/>
      <vk-carousel-arrow v-if="hasArrows" :size="48" class="ARROW RIGHT" direction="right"/>
      <vk-carousel-content ref="content" class="BUTTON-CONTENT">
        <div v-for="(button, index) in buttons" :key="index">
          <button
              :class="{ 'ACTIVE': index === activeIndex }"
              class="BUTTON"
              @click="onButtonSelect(index)">
            {{ button.label }}
          </button>
        </div>
      </vk-carousel-content>
    </template>
  </vk-carousel>
</template>

<script>
export default {
  name: 'buttons',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      canScroll: false,
      activeIndex: 0,
    };
  },
  computed: {
    hasArrows () {
      return this.$device.isMobile || (this.$device.isTablet && this.canScroll);
    },
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        const { $el } = this.$refs.content;
        this.canScroll = $el.scrollWidth > $el.clientWidth;
      }, 200);
    });
  },
  methods: {
    onButtonSelect (index) {
      this.activeIndex = index;
      this.$emit('on-index-select', index);
      if (this.canScroll) {
        this.$refs.carousel.scrollToIndex(this.activeIndex);
      }
    },
    updateActiveIndex (event) {
      this.activeIndex = event.visibleIndex;
      this.$emit('on-index-select', event.visibleIndex);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .BUTTONS-CAROUSEL {
    position: relative;
    .ARROW {
      opacity: 1;
      box-shadow: none;
    $arrow-size: 48px;
    position: absolute;
    top: calc(50% - (#{$arrow-size}/2));
      &.LEFT {
        left: calc(50% - (28 * #{$unit}/2 + #{$arrow-size}));
      }
      &.RIGHT {
        right: calc(50% - (28 * #{$unit}/2 + #{$arrow-size}));
      }
    }
  }
  /deep/ .CAROUSEL-ARROW{
    color: $color-depot;
    background-color: transparent;
    box-shadow: none;
  }
  /deep/ .DISABLED > .CAROUSEL-ARROW {
    background-color: transparent;
  }
  .BUTTON-CONTENT {
    white-space: nowrap;
    justify-content: space-between;
    text-align: center; // Center children items
     @include mobile-only { max-width : 28 * $unit }
  }
  .BUTTON {
    font-weight: 600;
    width: 28 * $unit ;
    height: 5.5 * $unit ;
    border: 1px solid #CCCCCC;
    background-color: #FFFFFF;
    border-radius: 4px;
    outline: 0;
    &:not(.ACTIVE) {
      color: $color-gray70;
      background-color: white;
    }
    &.ACTIVE {
      border: 2px solid $color-depot;

    }
  }
</style>
